import('./title.css');
export default {
  "modifiers": {
    "4xl": "pf-m-4xl",
    "3xl": "pf-m-3xl",
    "2xl": "pf-m-2xl",
    "xl": "pf-m-xl",
    "lg": "pf-m-lg",
    "md": "pf-m-md",
    "overpassFont": "pf-m-overpass-font"
  },
  "title": "pf-c-title"
};